/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Link_CopiedInputs */

const en_directory_submit_enrich_link_copied = /** @type {(inputs: Directory_Submit_Enrich_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied to clipboard`)
};

const zh_directory_submit_enrich_link_copied = /** @type {(inputs: Directory_Submit_Enrich_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接已复制到剪贴板`)
};

/**
* | output |
* | --- |
* | "Link copied to clipboard" |
*
* @param {Directory_Submit_Enrich_Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_link_copied = /** @type {((inputs?: Directory_Submit_Enrich_Link_CopiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Link_CopiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_link_copied(inputs)
	return zh_directory_submit_enrich_link_copied(inputs)
});
export { directory_submit_enrich_link_copied as "directory.submit.enrich.link_copied" }